import { Box, Typography } from '@mui/material';

import { abTestColors } from 'colors';

// Send index to letter mapping for A/B testing
const SEND_LABELS = ['A', 'B', ''] as const;

// Background colors for send labels using existing theme colors
const SEND_LABEL_COLORS = {
    A: abTestColors.emailA, // '#FCCFB0'
    B: abTestColors.emailB, // '#B4C5FF'
    R: abTestColors.remaining,
    '': abTestColors.remaining, // '#D9D9D9'
} as const;

type Props = {
    label: string;
    size?: 'small' | 'medium';
};

// Reusable A/B Test Label Box component
const ABTestLabelBox = ({ label, size = 'small' }: Props) => {
    const backgroundColor = SEND_LABEL_COLORS[label as keyof typeof SEND_LABEL_COLORS] || '#E0E0E0';

    // Use EmailContentStep styling for medium, smaller for schedule display
    const boxSize = size === 'medium' ? 32 : 24;
    const borderRadius = size === 'medium' ? '8px' : 1;

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: boxSize,
                height: boxSize,
                backgroundColor,
                borderRadius,
                fontWeight: 'bold',
                fontSize: size === 'medium' ? '0.875rem' : '0.75rem',
                marginRight: 1,
                color: '#000',
            }}
        >
            <Typography variant={size === 'medium' ? 'body2' : 'caption'} fontWeight="bold" component="span">
                {label}
            </Typography>
        </Box>
    );
};

// Utility function to get send label by index
export const getSendLabel = (index: number): string => SEND_LABELS[index] ?? `Send ${index + 1}`;

export default ABTestLabelBox;
